export const PaymentEndpoints = {
  makeManualPayment: "/manual",
  confirmManualPayIntent: "/manual/confirm-pay-intent/:id",
  cancelManualPayIntent: "/manual/cancel-pay-intent",
  getManualPaymentHistory: "/manual/history",
  // Pay by Bank — a PaymentIntent-only endpoint (no server-side .confirm()),
  // see services/payment/src/controllers/manual.ts's createPayByBankPay.
  // Deliberately NOT richAuth-gated: Stripe's bank-selection UI can't
  // render at all until this PaymentIntent (its clientSecret) exists, so
  // gating creation itself would force the WebAuthn step-up before the
  // admin has even seen the bank UI. The step-up instead happens right
  // before the actual payment confirm — see verifyManualPayByBankAuth.
  createManualPayByBankIntent: "/manual/pay-by-bank",
  // richAuth-only checkpoint (no side effect beyond the auth check itself)
  // called by PayByBank.vue immediately before stripe.confirmPayment() —
  // Stripe's own confirm call is a direct browser-to-Stripe request with
  // no backend hop of ours to gate, so this is the last point our backend
  // can verify admin identity before the bank redirect happens.
  verifyManualPayByBankAuth: "/manual/pay-by-bank/verify",
  // Manual Payment by Direct Debit from a bank account already saved to the
  // admin's Stripe customer — creates AND confirms the debit server-side, so
  // unlike the Payment Element flow above it is richAuth-gated itself.
  makeManualSavedBankPayment: "/manual/pay-saved-bank",

  addPaymentMethod: "/methods",
  getPaymentMethods: "/methods",
  deletePaymentMethods: "/methods/:id",
  // Saved Bacs Direct Debit bank accounts (admin Settings → Payment Methods →
  // Bank Accounts tab). Two path segments after /methods so they can't be
  // swallowed by the single-segment POST /methods/:id card-removal route above.
  getBankAccounts: "/methods/bank-accounts",
  // Starts Stripe-hosted Checkout (setup mode) to add a Bacs bank account —
  // Stripe: the Payment Element can't create Bacs SetupIntents. Registered
  // BEFORE removeBankAccount in routes/methods.ts, since "setup" would
  // otherwise be swallowed as that route's :id.
  startBankAccountSetup: "/methods/bank-accounts/setup",
  removeBankAccount: "/methods/bank-accounts/:id",
  getCarerWallet: "/carer",
  getCarerWalletById: "/carer/:id",
  payCarer: "/pay",

  // Booking Pay by Bank is called directly by the client portal, bypassing
  // the usual client-service gRPC relay — Pay by Bank needs a client_secret
  // in the browser to mount Stripe's Payment Element, and there was no
  // existing HTTP surface on the payment service for booking payments to
  // build that relay through.
  createBookingPayByBankIntent: "/booking/pay-by-bank",
};
